import { render } from "./ProductSections.vue?vue&type=template&id=7a66f92b&scoped=true"
import script from "./ProductSections.vue?vue&type=script&lang=js"
export * from "./ProductSections.vue?vue&type=script&lang=js"

import "./ProductSections.vue?vue&type=style&index=0&id=7a66f92b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a66f92b"]])

export default __exports__